import jwtDecode from "jwt-decode";


export const getToken = () => {
    try {
        const token = localStorage.getItem("token");
        const decodedToken = jwtDecode(token);
        let currentDate = new Date();
        if (decodedToken.exp * 1000 < currentDate.getTime()) {
            return null;
        } else {
            return token
        }
    } catch (err) {
        return null;
    }

}

export const setToken = (token) => {
    localStorage.setItem("token", token);
}

export const removeToken = () => {
    localStorage.removeItem("token");
}